import { render, staticRenderFns } from "./parenti.vue?vue&type=template&id=67752b21&scoped=true&"
import script from "./parenti.vue?vue&type=script&lang=js&"
export * from "./parenti.vue?vue&type=script&lang=js&"
import style0 from "./parenti.vue?vue&type=style&index=0&id=67752b21&scoped=true&lang=css&"
import style1 from "./parenti.vue?vue&type=style&index=1&lang=css&"
import style2 from "./parenti.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67752b21",
  null
  
)

export default component.exports